<div class="row full-services-layout align-items-center align-items-xl-start justify-content-center justify-content-xl-start">
    <div>
        <div class="col-12 service-title" [ngClass]="{ 'assist-override':id == 'assist' }">{{ title }}</div>
        <div class="d-none d-xl-block col-9 service-content" [ngClass]="{ 'assist-override':id == 'assist' }">{{ content }}</div>
    </div>
</div>